const menuList = [
  {
    name: '业务管理', path: '/business', icon: 'el-icon-s-order',
    children: [
      {
        name: '销售相关', path: '/sales',
        children: [
          { name: '自产项目', path: '/sales/project' },
          { name: '销售合同', path: '/sales/contract' },
          { name: '销售出库', path: '/sales/out' },
          { name: '销售退货', path: '/sales/return' }
        ]
      },
      {
        name: '受托相关', path: '/custom',
        children: [
          { name: '受托合同', path: '/custom/contract' },
          { name: '受托出库', path: '/custom/out' },
          { name: '受托退货', path: '/custom/return' }
        ]
      }
    ]
  },
  {
    name: '采购管理', path: '/purchase', icon: 'el-icon-shopping-cart-2',
    children: [
      { name: '采购计划', path: '/purchase/plan' },
      { name: '采购订单', path: '/purchase/order' },
      { name: '采购入库', path: '/purchase/in' },
      { name: '采购退货', path: '/purchase/return' }
    ]
  },
  {
    name: '生产管理', path: '/production', icon: 'el-icon-setting',
    children: [
      { name: '排产计划', path: '/production/plan' },
      { name: '物料计划', path: '/production/material-plan' },
      { name: '领料出库', path: '/production/pick' },
      { name: '成品入库', path: '/production/finished-in' },
      { name: '退料入库', path: '/production/return-material' },
      { name: '生产结算', path: '/production/settlement' },
      { name: '人工记录', path: '/production/labor' },
      { name: '入场记录', path: '/production/entry' },
      { name: '领票记录', path: '/production/ticket' },
      { name: '办公室使用记录', path: '/production/office' }
    ]
  },
  {
    name: '仓库管理', path: '/warehouse', icon: 'el-icon-s-home',
    children: [
      { name: '库存台账', path: '/warehouse/inventory' },
      { name: '库存盘点', path: '/warehouse/check' },
      { name: '库存调拨', path: '/warehouse/transfer' },
      { name: '库存流水', path: '/warehouse/flow' },
      { name: '运送记录', path: '/warehouse/transport' },
      // 客户物料档案已并入「物料管理-物料档案」；客户领用/退库已并入「生产管理-领料出库/退料入库」
      { name: '来料入库', path: '/customer-material/incoming' },
      { name: '查询对账', path: '/customer-material/inventory' },
      { name: '清库出库', path: '/customer-material/clear-out' }
    ]
  },
  {
    name: '物料管理', path: '/material', icon: 'el-icon-goods',
    children: [
      { name: '物料分类', path: '/material/category' },
      { name: '物料档案', path: '/material/archive' }
    ]
  },
  {
    name: '质量管理', path: '/quality', icon: 'el-icon-s-check',
    children: [
      { name: '检验记录', path: '/quality/test' },
      { name: '实验室使用记录', path: '/quality/lab' },
    ]
  },
  {
    name: '单据录入', path: '/form', icon: 'el-icon-document',
    children: [
      { name: '填写记录', path: '/form/record-list' },
    ]
  },
  {
    name: '基础数据', path: '/basic', icon: 'el-icon-s-tools',
    children: [
      { name: '仓库管理',   path: '/basic/warehouse' },
      { name: '车间管理',   path: '/basic/workshop' },
      { name: '实验室管理', path: '/basic/lab' },
      { name: '办公室管理', path: '/basic/office' },
      { name: '设备类型',   path: '/basic/equipment-type' },
      { name: '设备信息',   path: '/basic/equipment' },
      { name: '往来单位',   path: '/basic/company' }
    ]
  },
  {
    name: '审批工作流', path: '/approval', icon: 'el-icon-s-claim',
    children: [
      { name: '审批配置', path: '/approval/config' },
      { name: '审批记录', path: '/approval/records' }
    ]
  },
  {
    name: '报表查询', path: '/report', icon: 'el-icon-s-data',
    children: [
      { name: '库存收发存报表', path: '/report/inventory' },
      { name: '受托生产对账单', path: '/report/customer-bill' },
      { name: '采购/销售台账', path: '/report/ps-ledger' },
      { name: '批次追踪报表', path: '/report/batch-trace' },
      { name: '生产进度报表', path: '/report/progress' },
      { name: '质量统计报表', path: '/report/quality-stat' },
      { name: '盘点差异报表', path: '/report/check-diff' },
      { name: '物料需求汇总表', path: '/report/material-demand' }
    ]
  },
  {
    name: '系统管理', path: '/system', icon: 'el-icon-s-tools',
    children: [
      { name: '部门管理', path: '/system/dept' },
      { name: '用户管理', path: '/system/user' },
      { name: '角色权限', path: '/system/role' },
      { name: '编码规则', path: '/system/code-rule' },
      { name: '系统参数', path: '/system/params' },
      { name: '模板管理', path: '/system/template' },
      { name: '操作日志', path: '/system/log' }
    ]
  }
]

export default menuList

export function getAllPaths(items) {
  const paths = []
  for (const item of items) {
    paths.push(item.path)
    if (item.children) {
      paths.push(...getAllPaths(item.children))
    }
  }
  return paths
}

export function flattenTree(items) {
  const result = []
  for (const item of items) {
    result.push(item)
    if (item.children) {
      result.push(...flattenTree(item.children))
    }
  }
  return result
}
